import React, { FC, memo } from 'react';
import { Redirect } from 'react-router';
import { useLoggedIn } from '../../global-state/auth-state';
import { routes } from '../../routing/routes';
import { Login } from './login';

export const Home: FC<{}> = memo(() => {
  const loggedIn = useLoggedIn();
  switch (loggedIn) {
    case false:
      return <Login />;
    case true:
      return <Redirect to={routes.main} />;
    case undefined:
    default:
      return <div />;
  }
});

Home.displayName = 'Home';
